import React from "react"
import { Button, Input } from "antd"

export default class EditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            identity: '',
            birthday: '',
            hmo: '',
            shaban: ''
        }
    }

    save = (e) => {
        e.preventDefault()

        const { user, setEdit, updateList } = this.props
        
        let obj = {
            tempId: user.tempId
        }

        for (let el in e.target.elements) {
            let target = e.target.elements[el] 
            if (target.id && target.id.includes('input-')) {
                obj[target.id.split('-')[1]] = target.value
            }
        }

        updateList(obj)
        setEdit(null)
    }

    cancel = (e) => {
        e.preventDefault()
        this.props.setEdit(null)
    }

    checkError = (errorArray, errorString) => {
        return errorArray.find((error) => error.includes(errorString))
    }

    errors = {
        phone: this.props.user.typeErr &&
                   this.checkError(this.props.user.typeErr, 'PHONE'),
        identity: this.props.user.typeErr &&
                   this.checkError(this.props.user.typeErr, 'IDENTITY'),
        email: this.props.user.typeErr &&
                   this.checkError(this.props.user.typeErr, 'EMAIL'),

        crm_phone: this.props.user.crmErr &&
                        this.checkError(this.props.user.crmErr, 'PHONE'),
        crm_identity: this.props.user.crmErr &&
                        this.checkError(this.props.user.crmErr, 'IDENTITY'),
        crm_email: this.props.user.crmErr &&
                        this.checkError(this.props.user.crmErr, 'EMAIL'),
    }

    errorColor = (field) => {
        if (this.errors[field] && this.errors[`crm_${field}`]) {
            return 'red'
        } else if (this.errors[field]) {
            return 'orange'
        } else if (this.errors[`crm_${field}`]) {
            return 'purple'
        }
    }

    render() {
        const { user } = this.props        
        return (
            <div style={{ ...style.line }}>
                <form onSubmit={this.save} style={{ ...style.inner }}>
                    <div style={{ ...style.cell }}>
                        <span>שם פרטי:</span>
                        <Input id="input-first_name" defaultValue={user.first_name} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span>שם משפחה:</span>
                        <Input id="input-last_name" defaultValue={user.last_name} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span style={{ color: this.errorColor('phone') }}>טלפון:</span>
                        <Input id="input-phone" defaultValue={user.phone} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span style={{ color: this.errorColor('email') }}>אימייל:</span>
                        <Input id="input-email" defaultValue={user.email} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span style={{ color: this.errorColor('identity') }}>מ. זהות:</span>
                        <Input id="input-identity" defaultValue={user.identity} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span>ת. לידה:</span>
                        <Input id="input-birthday" defaultValue={user.birthday} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span>קופ״ח:</span>
                        <Input id="input-hmo_id" defaultValue={user.hmo_id} />
                    </div>
                    <div style={{ ...style.cell }}>
                        <span>שב״ן:</span>
                        <Input id="input-hmo_plan_id" defaultValue={user.hmo_plan_id} />
                    </div>
                    <div style={{ alignSelf: 'end', marginBottom: '-4px' }}>
                        <Button htmlType="submit">{"שמירה"}</Button>
                        <Button onClick={this.cancel}>{"ביטול"}</Button>
                    </div>
                </form>
            </div>
        )
    }
}

const style = {
    line: { width: '100%', height: '50px', marginBottom: '34px' },
    inner: { display: 'flex', justifyContent: 'space-between', width: '100%', height: '100%' },
    cell: { width: '11%' }
}